module.exports = __webpack_public_path__ + "static/media/pltw_logo_atom_white.ad35c752.svg";